module.exports = __webpack_public_path__ + "img/cheese.c317c233.svg";